import React, {useReact} from 'react';
import { Row, Col } from 'react-bootstrap';
import numeral from 'numeral';

const View = (props) => {
    return (
        <div className="p-0">
            <div className="p-2">Barang</div>
            {
                props.items.map(i => {
                    return (
                        <div className="card">
                            <Row>
                                <Col sm={2}>
                                    {i.quantity}x
                                </Col>
                                <Col sm={6}>
                                    <div><b>{i.name}</b></div>
                                    {i.description}
                                </Col>
                                <Col sm={4}>
                                    <div>Berat {i.weight} gram</div>
                                    <div>Ukuran {i.length}x{i.width}x{i.height}</div>
                                </Col>
                            </Row>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default View